import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SlimScrollModule } from 'ng2-slimscroll';
import { FeedbackListComponent } from './feedback-list/feedback-list.component';
import { FeedbackReplyComponent } from './feedback-reply/feedback-reply.component';
import { FeedbackForwardComponent } from './feedback-forward/feedback-forward.component';
import {SharedModule} from './../shared/shared.module';
import {FeedbackRoutingModule} from './feedback-routing.module';
import {FeedbackPipe} from './feedback.search';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SlimScrollModule,
    FeedbackRoutingModule
  ],
  declarations: [FeedbackListComponent, FeedbackReplyComponent, FeedbackForwardComponent, FeedbackPipe]
})
export class FeedbackModule { }



// WEBPACK FOOTER //
// ./src/app/feedback/feedback.module.ts